module.exports = __webpack_public_path__ + "img/icon-check-gray.c731909c.svg";